@let orgChartId = store.orgChartIdSg();
@if (orgChartId) {
  @let editingNode =
    store.orgChartFeature.selectors.getEditingNode({ orgChartId }).asSignal();
  @if (editingNode) {
    <atn-ds-widget
      class="atn-summit-org-chart-node-panel"
      [title]="
        editingNode.name +
        (editingNode.person ? ' (' + editingNode.person + ')' : '')
      "
    >
      <atn-summit-org-chart-node-panel-body
        class="atn-summit-org-chart-node-panel__body"
      />
      <atn-summit-org-chart-node-panel-footer
        footer
        class="atn-summit-org-chart-node-panel__footer"
      />
    </atn-ds-widget>
  }
}
